import MyCard from "../Card";
import {Divider, Layout} from 'antd';
import React from "react";
import {Link} from 'react-router-dom';
import rats from './images/Rats.png';
import wildfire from './images/Wildfire.gif';
import solar from './images/Solar.png';
import svi from './images/StreetView.jpg';
import pgRouting from './images/pgRouting.png';
import servicearea from './images/ServiceArea.png'
import homelessness from './images/Homelessness.jpg';
import opendefecation from './images/OpenDefecation.jpeg';
import surface_albedo from './images/Surface_Albedo.jpg';
import surface_mrt from './images/SurfaceMRT.jpg';
import parkentrance from './images/ParkEntrance.jpg';
import solar_LCZ from './images/Solar_LCZ.jpg';
import GI from './images/GI_Planning.jpg';
import NPE from './images/NPE.jpg';
import TOD from './images/TOD.jpg';
import SVG from './images/SVG.jpg';
import Waste from './images/Waste.jpg';
import UFUG_128776 from './images/UFUG128776.jpg';
import GSM_UTCI from './images/GSM_UTCI.jpg';
import Seasonal_bias from './images/Seasonal.png';
import HFPCS from './images/HFPCS.png';
import UTCI from './images/UTCI.jpg';
import DyGNN from './images/MM-DyGNN.jpg';
import JTG from './images/JTGFrameWork.png';
import Soundscape from './images/Soundscape.jpg';
import PLOS from './images/PLOS.PNG';
import DRL from './images/DRL_framework.png';
import PV from './images/PV.jpg';
import LMEMR from './images/LMEMR.png';
import LST_UTCI from './images/LST_UTCI.jpg';
import Cyclist from './images/Heat_Cyclist.png';
import DRL_paper from './publications/DRL.pdf';

const {Content} = Layout;

const Projects = () => (
    <div className="content-centered">
        <Content className="work-content">
            <Divider id="data-analytics" orientation="left" className="dynamic-font-divider">Data Analytics</Divider>
            <div className="image-grid">
                <Link to="/RATScreener">
                    <MyCard
                        hoverable
                        imageUrl={rats}
                        title="A Vermin Inspection Optimization Tool"
                        description="Machine learning, Data analysis">
                    </MyCard>
                </Link>
                <Link to="/Wildfire">
                    <MyCard
                        hoverable
                        imageUrl={wildfire}
                        title="Forecasting Wildfire Risk in California"
                        description="Machine Learning, Data analysis">
                    </MyCard>
                </Link>
                <Link to="/Solar">
                    <MyCard
                        hoverable
                        imageUrl={solar}
                        title="Solar Roof Operations in Philadelphia"
                        description="Front-end, Web design, Visualization">
                    </MyCard>
                </Link>
            </div>
            <br/>
            <Divider id="researches" orientation="left" className="dynamic-font-divider">Publications</Divider>
            <div className="image-grid">
                <a href={'https://www.nature.com/articles/s44432-026-00015-3'} target="_blank" rel="noopener noreferrer">
                    <MyCard
                        hoverable
                        imageUrl={Cyclist}
                        title="High-resolution urban microclimate modeling reveals hyperlocal cycling heat stress disparities in New York City"
                        journal="Accepted by npj Environmental Social Sciences"
                        description="UTCI, Cycling behaviour, Microclimate modeling, Heat exposure disparity">
                    </MyCard>
                </a>
                <a href={'https://doi.org/10.1016/j.scs.2026.107659'} target="_blank" rel="noopener noreferrer">
                    <MyCard
                        hoverable
                        imageUrl={LST_UTCI}
                        title="From physical surfaces to human-centric heat stress: LST and UTCI heat mapping reveals nonlinear effects of urban morphology"
                        journal="Accepted by Sustainable Cities and Society"
                        description="UTCI, Urban morphology, GeoAI, Spatial heterogeneity, Climate-adaptive planning">
                    </MyCard>
                </a>
                <a href={'https://doi.org/10.1016/j.enbuild.2026.117929'} target="_blank" rel="noopener noreferrer">
                    <MyCard
                        hoverable
                        imageUrl={PV}
                        title="Unravelling nonlinear effects of urban morphology on rooftop PV adoption using explainable machine learning"
                        journal="Accepted by Energy and Buildings"
                        description="Urban morphology, Rooftop photovoltaic, Realistic adoption, Built environment, Installed panel">
                    </MyCard>
                </a>
                <a href={'https://doi.org/10.1080/13658816.2025.2595655'} target="_blank" rel="noopener noreferrer">
                    <MyCard
                        hoverable
                        imageUrl={DyGNN}
                        title="Adaptive dynamic graph learning for forecasting urban multimodal flow"
                        journal="Accepted by International Journal of Geographical Information Science"
                        description="Urban multimodal flow, Dynamic graph neural network, Cross-modal interaction, Multitask learning, Spatiotemporal modeling">
                    </MyCard>
                </a>
                <a href={'https://ieeexplore.ieee.org/document/11540094'} target="_blank" rel="noopener noreferrer">
                    <MyCard
                        hoverable
                        imageUrl={LMEMR}
                        title="Learning fine-grained urban mobility dynamics through large model-enhanced multimodal representations"
                        journal="Accepted by IEEE Transactions on Intelligent Transportation Systems"
                        description="Urban mobility prediction, Multimodal learning,Vision–language models, Contrastive learning, Graph attention networks">
                    </MyCard>
                </a>
                <a href={'https://doi.org/10.1016/j.compenvurbsys.2026.102412'} target="_blank" rel="noopener noreferrer">
                    <MyCard
                        hoverable
                        imageUrl={Soundscape}
                        title="Decoding urban soundscapes: spatial prediction and influence mechanism analysis with interpretable semi-supervised learning"
                        journal="Accepted by Computers, Environment and Urban Systems"
                        description="Urban soundscape, Sound level prediction, Sound source classification, Interpretable machine learning, Semi-supervised learning">
                    </MyCard>
                </a>
                <a href={'https://doi.org/10.1371/journal.pone.0341844'} target="_blank" rel="noopener noreferrer">
                    <MyCard
                        hoverable
                        imageUrl={PLOS}
                        title="Developing a machine learning model to map new-build gentrification: A mixed-methods approach"
                        journal="Accepted by PLOS One"
                        description="Build gentrification, Street view images, Machine learning, ">
                    </MyCard>
                </a>
                 <a href={'https://doi.org/10.1016/j.jtrangeo.2026.104553'} target="_blank" rel="noopener noreferrer">
                    <MyCard
                        hoverable
                        imageUrl={JTG}
                        title="Assessing nighttime homeless shelter accessibility and its socioeconomic associations in Los Angeles"
                        journal="Accepted by Journal of Transport Geography"
                        description="Homeless shelters, Accessibility, G2SFCA, Geographically weighted regression, Spatial analysis">
                    </MyCard>
                </a>
                <a href={'https://doi.org/10.1080/13658816.2025.2595655'} target="_blank" rel="noopener noreferrer">
                    <MyCard
                        hoverable
                        imageUrl={DyGNN}
                        title="Adaptive dynamic graph learning for forecasting urban multimodal flow"
                        journal="Accepted by IJGIS"
                        description="Urban multimodal flow, Dynamic graph neural network, Cross-modal interaction, Multitask learning, learning, Spatiotemporal modeling">
                    </MyCard>
                </a>
                <a href={'https://doi.org/10.1016/j.ufug.2025.129101'} target="_blank" rel="noopener noreferrer">
                    <MyCard
                        hoverable
                        imageUrl={GSM_UTCI}
                        title="Planning for cooler cities: A multimodal AI framework for hyperlocal spatio-temporal urban heat stress prediction and mitigation"
                        journal="Accepted by Urban Forestry & Urban Greening"
                        description="Heat stress, Multimodal deep learning, UTCI, SOLWEIG, Landscape transformation">
                    </MyCard>
                </a>
                <a href={'https://doi.org/10.1016/j.compenvurbsys.2025.102341'} target="_blank" rel="noopener noreferrer">
                    <MyCard
                        hoverable
                        imageUrl={UTCI}
                        title="Hyperlocal Heat Stress around Bus Stops in Philadelphia: Insights from Spatio-Temporal Microclimate Modeling and Explainable AI"
                        journal="Accepted by Computers, Environment and Urban Systems"
                        description="Heat stress, Bus stops, Urban environment, SHAP, Nonlinear relationship, UTCI">
                    </MyCard>
                </a>
                <Link to="/Albedopedia">
                    <MyCard
                        hoverable
                        imageUrl={surface_albedo}
                        title="A sub-meter resolution urban surface albedo dataset for 34 U.S. cities based on deep learning"
                        journal="Accepted by Scientific Data (Nature Portfolio)"
                        description="Surface albedo, deep learning, high-resolution, dataset">
                    </MyCard>
                </Link>
                <a href={'https://doi.org/10.3390/smartcities8030083'} target="_blank" rel="noopener noreferrer">
                    <MyCard
                        hoverable
                        imageUrl={HFPCS}
                        title="Evaluating the Quality of High-Frequency Pedestrian Commuting Streets: A Data-Driven Approach in Shenzhen"
                        journal="Accepted by Smart Cities"
                        description="High-frequency pedestrian commuting streets, Street quality assessment, Big data, Human-centric urban design">
                    </MyCard>
                </a>
                <Link to="/Homelessness">
                    <MyCard
                        hoverable
                        imageUrl={homelessness}
                        title="Uncovering nonlinear urban factors of homelessness: Evidence from New York City using interpretable machine learning"
                        journal="Accepted by Environment and Planning B: Urban Analytics and City Science"
                        description="Homelessness, Urban big data, Street view imagery, Interpretable machine learning, SHapley additive explanations">
                    </MyCard>
                </Link>
                <a href={'https://doi.org/10.1016/j.compenvurbsys.2025.102302'} target="_blank" rel="noopener noreferrer">
                    <MyCard
                        hoverable
                        imageUrl={Seasonal_bias}
                        title="Quantifying seasonal bias in street view imagery for urban form assessment: A global analysis of 40 cities"
                        journal="Accepted by Computers, Environment and Urban Systems"
                        description="Google street view, Urban sensing, GeoAI, Data quality, Consistency">
                    </MyCard>
                </a>
                <a href={'https://doi.org/10.1016/j.ufug.2025.128776'} target="_blank" rel="noopener noreferrer">
                    <MyCard
                        hoverable
                        imageUrl={UFUG_128776}
                        title="Adaptive ranking of specific tree species for targeted green infrastructure intervention in response to urban hazards"
                        journal="Accepted by Urban Forestry & Urban Greening"
                        description="Green infrastructure planning, Nature-based solutions, Decision-making, i-Tree Eco model, Urban hazards, Multifunctionality">
                    </MyCard>
                </a>
                <a href={'https://doi.org/10.1016/j.scs.2025.106168'} target="_blank" rel="noopener noreferrer">
                    <MyCard
                        hoverable
                        imageUrl={Waste}
                        title="Optimizing urban agricultural waste planning and management to enhance sustainability: Strategies for three types of cities"
                        journal="Accepted by Sustainable Cities and Society"
                        description="Urban waste, Sustainability, Spatial planning, MCDM, Scenario analysis, Renewable energy">
                    </MyCard>
                </a>
                <Link to="/SurfaceMRT">
                    <MyCard
                        hoverable
                        imageUrl={surface_mrt}
                        title="Assessing the differential impact of suburban vegetated and urban built-up areas on heat exposure environment: A case study in Los Angeles"
                        journal="Accepted by Building and Environment"
                        description="Vegetated areas, Built-up areas, mean radiant temperature, urban surface albedo, SHAP">
                    </MyCard>
                </Link>
                <a href={'https://doi.org/10.1177/23998083241312272'} target="_blank" rel="noopener noreferrer">
                    <MyCard
                        hoverable
                        imageUrl={SVG}
                        title="Exploring the associations between street-view green space quantity and quality, and influenza in Guangzhou, China through machine learning and spatial regression: A socio-economic equity perspective"
                        journal="Accepted by Environment and Planning B: Urban Analytics and City Science"
                        description="Street-view green space, Quantity and quality, Influenza, Socio-economic equity, Street-view data">
                    </MyCard>
                </a>
                <a href={'https://doi.org/10.1016/j.jenvman.2024.123274'} target="_blank" rel="noopener noreferrer">
                    <MyCard
                        hoverable
                        imageUrl={TOD}
                        title="Are different TOD circles oriented towards sustainability amidst urban shrinkage? Evidence from urban areas to suburbs in the Tokyo metropolitan area"
                        journal="Accepted by Journal of Environmental Management"
                        description="Transit-Oriented development (TOD), TOD circles, Node-place-ecology model, Sustainable development Node-place model">
                    </MyCard>
                </a>
                <a href={'https://doi.org/10.1016/j.trd.2024.104456'} target="_blank" rel="noopener noreferrer">
                    <MyCard
                        hoverable
                        imageUrl={NPE}
                        title="Enhancing transit-oriented development sustainability through the integrated node-place-ecology (NPE) model"
                        journal="Accepted by Transportation Research Part D: Transport and Environment"
                        description="Transit-oriented development, Node-place model, Node-place-ecology model, Timeline-based, Sustainable development line">
                    </MyCard>
                </a>
                <a href={'https://doi.org/10.1016/j.scs.2024.105767'} target="_blank" rel="noopener noreferrer">
                    <MyCard
                        hoverable
                        imageUrl={GI}
                        title="Planning for green infrastructure by integrating multi-driver: Ranking priority based on accessibility-equity"
                        journal="Accepted by Sustainable Cities and Society"
                        description="Green infrastructure planning, Urban ecosystem, Multifunctionality, Sponge city, Nature-based solution">
                    </MyCard>
                </a>
                <a href={'https://doi.org/10.1016/j.compenvurbsys.2024.102176'} target="_blank" rel="noopener noreferrer">
                    <MyCard
                        hoverable
                        imageUrl={solar_LCZ}
                        title="LCZ-based city-wide solar radiation potential analysis by coupling physical modeling, machine learning, and 3D buildings"
                        journal="Accepted by Computers, Environment and Urban Systems"
                        description="Solar radiation potential, Machine learning, Local climate zone, 3D buildings">
                    </MyCard>
                </a>
                <Link to="/OpenDefecation">
                    <MyCard
                        hoverable
                        imageUrl={opendefecation}
                        title="Interpretable spatial machine learning insights into urban sanitation challenges: A case study of human feces distribution in San Francisco"
                        journal="Accepted by Sustainable Cities and Society"
                        description="Urban sanitation, Open defecation, Spatial IML, SHAP">
                    </MyCard>
                </Link>
                <a href={'https://doi.org/10.1016/j.jclepro.2024.142951'} target="_blank" rel="noopener noreferrer">
                    <MyCard
                        hoverable
                        imageUrl={parkentrance}
                        title="Effective or useless? Assessing the impact of park entrance addition policy on green space services from the 15-minute city perspective"
                        journal="Accepted by Journal of Cleaner Production"
                        description="Urban parks, Park entrance, Accessibility, 15-minute city">
                    </MyCard>
                </a>
                <a href={DRL_paper} target="_blank" rel="noopener noreferrer">
                    <MyCard
                        hoverable
                        imageUrl={DRL}
                        title="Deep online recommendations for connected E-taxis by coupling trajectory mining and reinforcement learning"
                        journal="Accepted by IJGIS"
                        description="Deep reinforcement learning">
                    </MyCard>
                </a>
                {/*<a href={'https://search.ebscohost.com/login.aspx?direct=true&profile=ehost&scope=site&authtype=crawler&jrnl=10000232&AN=171793816&h=Szz13CBriVmeoTOHKt6PNEP1awcu3RbygOnwpJWcgFW7fIs2QzTvdp2bX7L6IDvceRDK7yQHrVReJeYM6cqpcQ%3D%3D&crl=c'} target="_blank" rel="noopener noreferrer">*/}
                {/*    <MyCard*/}
                {/*        hoverable*/}
                {/*        imageUrl={Frequent_street}*/}
                {/*        title="High Frequency Street"*/}
                {/*        journal="Accepted by South Architecture"*/}
                {/*        description="">*/}
                {/*    </MyCard>*/}
                {/*</a>*/}
            </div>
            <br/>
            <Divider id="funny-tool" orientation="left" className="dynamic-font-divider">Funny Tools</Divider>
            <div className="image-grid">
                 <a href="https://github.com/ShengaoYi/Google-StreetView-Downloader" target="_blank" rel="noopener noreferrer">
                    <MyCard
                        hoverable
                        imageUrl={svi}
                        title="Google StreetView Downloader"
                        description="Google Street View images, Road Network">
                    </MyCard>
                </a>
                <a href="https://github.com/ShengaoYi/pgRouting_tutorial" target="_blank" rel="noopener noreferrer">
                    <MyCard
                        hoverable
                        imageUrl={pgRouting}
                        title="pgRouting Tutorial"
                        description="Network Analysis, PostGIS, PostgreSQL">
                    </MyCard>
                </a>
                <a href="https://github.com/ShengaoYi/NX-ServiceArea" target="_blank" rel="noopener noreferrer">
                    <MyCard
                        hoverable
                        imageUrl={servicearea}
                        title="Service Area"
                        description="ArcPy, NetworkX, PostgreSQL">
                    </MyCard>
                </a>
            </div>
        </Content>
    </div>
);

export default Projects;
